import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatValue } from './utils';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: nowrap;
  min-width: 0;
  overflow: hidden;
`;

const Chip = styled.span`
  display: inline-block;
  padding: 2px 9px;
  border-radius: 3px;
  font-family: 'JetBrains Mono', monospace;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex-shrink: 1;
  background: ${({ variant }) =>
    variant === 'before'
      ? 'var(--if-diff-remove-bg)'
      : 'var(--if-diff-add-bg)'};
  color: ${({ variant }) =>
    variant === 'before'
      ? 'var(--if-diff-remove-ink)'
      : 'var(--if-diff-add-ink)'};
`;

const Arrow = styled.span`
  color: var(--if-ink-3);
  font-size: 12px;
  flex-shrink: 0;
`;

export default function StringDiff({
  from = null,
  to = null,
  compact = false,
}) {
  const fromStr = formatValue(from);
  const toStr = formatValue(to);
  const maxLen = compact ? 30 : 80;

  const truncate = (str) =>
    str.length > maxLen ? `${str.slice(0, maxLen)}…` : str;

  return (
    <Wrapper>
      <Chip variant="before">{truncate(fromStr)}</Chip>
      <Arrow>&rarr;</Arrow>
      <Chip variant="after">{truncate(toStr)}</Chip>
    </Wrapper>
  );
}
StringDiff.propTypes = {
  from: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.object,
    PropTypes.array,
  ]),
  to: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool,
    PropTypes.object,
    PropTypes.array,
  ]),
  compact: PropTypes.bool,
};
